/* ==========================================================================
   VyomTara | Watch and Buy
   Standalone script. It only controls elements inside <vt-watch-and-buy>
   and its own popup. It does not change any existing theme script.
   ========================================================================== */
(function () {
  'use strict';

  if (window.customElements.get('vt-watch-and-buy')) return;

  var ICONS = {
    prev: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7"/></svg>',
    next: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7"/></svg>',
    close: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    sound: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M11 5L6 9H3v6h3l5 4V5z" fill="currentColor" stroke="none"/><path d="M15.5 8.5a5 5 0 010 7M18.5 5.5a9 9 0 010 13"/></svg>',
    muted: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M11 5L6 9H3v6h3l5 4V5z" fill="currentColor" stroke="none"/><path d="M16 9l5 6M21 9l-5 6"/></svg>',
    share: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="18" cy="5" r="2.5"/><circle cx="6" cy="12" r="2.5"/><circle cx="18" cy="19" r="2.5"/><path d="M8.2 10.8l7.6-4.4M8.2 13.2l7.6 4.4"/></svg>',
    link: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 01-1 1H5a1 1 0 01-1-1V7a1 1 0 011-1h5"/></svg>',
    play: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M8 5.5v13l11-6.5z"/></svg>',
    cart: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3 4h2.2l2.1 10.4a1.5 1.5 0 001.5 1.2h8.6a1.5 1.5 0 001.5-1.1L21 8H6.2"/><circle cx="9.5" cy="19.5" r="1.3"/><circle cx="17" cy="19.5" r="1.3"/></svg>',
    minus: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M5 12h14"/></svg>',
    plus: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14"/></svg>',
    check: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>'
  };

  function bool(value) {
    return value === 'true';
  }

  class VTWatchAndBuy extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      var d = this.dataset;
      this.opts = {
        autoSlide: bool(d.autoslide),
        autoSlideSpeed: Math.max(2, parseFloat(d.autoslideSpeed) || 4) * 1000,
        playback: d.playback || 'autoplay',
        centerHighlight: bool(d.centerHighlight),
        soundOnOpen: bool(d.soundOnOpen),
        showNeighbours: bool(d.showNeighbours),
        showMute: bool(d.showMute),
        showShare: bool(d.showShare),
        showProduct: bool(d.showProduct),
        showVariants: bool(d.showVariants),
        showCompare: bool(d.showCompare),
        afterAdd: d.afterAdd || 'stay',
        cartAddUrl: d.cartAddUrl || '/cart/add',
        cartUrl: d.cartUrl || '/cart',
        rootUrl: (d.rootUrl || '/').replace(/\/?$/, '/'),
        cartIconAction: d.cartIconAction || 'checkout',
        label: d.label || 'Watch and Buy',
        text: {
          add: d.textAdd || 'Add to cart',
          adding: d.textAdding || 'Adding...',
          added: d.textAdded || 'Added to cart',
          soldout: d.textSoldout || 'Sold out',
          unavailable: d.textUnavailable || 'Unavailable',
          error: d.textError || "Couldn't add to cart. Please try again.",
          copied: d.textCopied || 'Link copied',
          cancel: d.textCancel || 'Cancel',
          done: d.textDone || 'Done',
          select: d.textSelect || 'Please select a size',
          removed: d.textRemoved || 'Removed from cart',
          max: d.textMax || 'No more stock for this size',
          checkout: d.textCheckout || 'Go to checkout',
          share: d.textShare || 'Share'
        }
      };

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.isTouch = window.matchMedia('(hover: none)').matches;

      this.track = this.querySelector('[data-vt-track]');
      this.carousel = this.querySelector('[data-vt-carousel]');
      this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-vt-card]'));
      this.items = [];
      this.pauseUntil = 0;
      this.hovering = false;
      this.isOpen = false;
      this.index = 0;

      this.collectItems();
      if (!this.track) return;

      this.bindCarousel();
      this.setupCardVideos();
      this.startAuto();

      this.onBlockSelect = this.handleBlockSelect.bind(this);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      this.stopAuto();
      if (this.io) this.io.disconnect();
      if (this.onResize) window.removeEventListener('resize', this.onResize);
      if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      if (this.popup) {
        if (this.isOpen) this.close(true);
        this.popup.remove();
        this.popup = null;
      }
      this._ready = false;
    }

    /* ---------- Data ---------- */
    collectItems() {
      var self = this;
      this.cards.forEach(function (card) {
        var dataEl = card.querySelector('[data-vt-data]');
        if (!dataEl) return;
        var data;
        try {
          data = JSON.parse(dataEl.textContent);
        } catch (e) {
          return;
        }
        card.dataset.popupIndex = String(self.items.length);
        self.items.push(data);
      });
    }

    /* ---------- Carousel ---------- */
    bindCarousel() {
      var self = this;
      this.prevBtn = this.querySelector('[data-vt-prev]');
      this.nextBtn = this.querySelector('[data-vt-next]');

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', function () {
          self.pauseAutoFor(8000);
          self.scrollByStep(-1);
        });
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', function () {
          self.pauseAutoFor(8000);
          self.scrollByStep(1);
        });
      }

      this.track.addEventListener('scroll', function () {
        if (self._raf) return;
        self._raf = window.requestAnimationFrame(function () {
          self._raf = null;
          self.updateCenter();
        });
      }, { passive: true });

      this.track.addEventListener('mouseenter', function () { self.hovering = true; });
      this.track.addEventListener('mouseleave', function () { self.hovering = false; });
      this.track.addEventListener('touchstart', function () { self.pauseAutoFor(6000); }, { passive: true });
      this.track.addEventListener('focusin', function () { self.pauseAutoFor(8000); });

      this.track.addEventListener('click', function (event) {
        var opener = event.target.closest('[data-vt-open]');
        if (!opener) return;
        var card = opener.closest('[data-vt-card]');
        if (!card || card.dataset.popupIndex === undefined) return;
        event.preventDefault();
        self.open(parseInt(card.dataset.popupIndex, 10), opener);
      });

      this.onResize = function () {
        self.updateLayout();
        self.updateCenter();
      };
      window.addEventListener('resize', this.onResize);

      this.updateLayout();
      this.updateCenter();
      window.setTimeout(function () { self.updateLayout(); self.updateCenter(); }, 400);
    }

    getStep() {
      var card = this.cards[0];
      if (!card) return this.track.clientWidth;
      var gap = parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    scrollByStep(direction) {
      var t = this.track;
      var max = t.scrollWidth - t.clientWidth;
      if (max <= 4) return;
      var behavior = this.reducedMotion ? 'auto' : 'smooth';
      if (direction > 0 && t.scrollLeft >= max - 4) {
        t.scrollTo({ left: 0, behavior: behavior });
      } else if (direction < 0 && t.scrollLeft <= 4) {
        t.scrollTo({ left: max, behavior: behavior });
      } else {
        t.scrollBy({ left: direction * this.getStep(), behavior: behavior });
      }
    }

    updateLayout() {
      if (!this.carousel) return;
      var scrollable = this.track.scrollWidth - this.track.clientWidth > 4;
      this.carousel.classList.toggle('is-static', !scrollable);

      var firstCard = this.cards[0];
      var media = firstCard && firstCard.querySelector('.vt-wab__media');
      if (media) {
        var top = firstCard.getBoundingClientRect().top - this.carousel.getBoundingClientRect().top;
        this.carousel.style.setProperty('--vt-wab-arrow-top', Math.round(top + media.offsetHeight / 2) + 'px');
      }
    }

    updateCenter() {
      if (!this.opts.centerHighlight || !this.isTouch || !this.cards.length) return;
      var rect = this.track.getBoundingClientRect();
      var center = rect.left + rect.width / 2;
      var best = null;
      var bestDistance = Infinity;

      this.cards.forEach(function (card) {
        var r = card.getBoundingClientRect();
        var distance = Math.abs(r.left + r.width / 2 - center);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = card;
        }
      });

      var self = this;
      this.cards.forEach(function (card) {
        var active = card === best;
        card.classList.toggle('is-centered', active);
        if (self.opts.playback === 'hover') {
          var video = card.querySelector('.vt-wab__video');
          if (!video) return;
          if (active) self.playCardVideo(video);
          else video.pause();
        }
      });
    }

    startAuto() {
      if (!this.opts.autoSlide || this.reducedMotion || this.cards.length < 2) return;
      this.stopAuto();
      var self = this;
      this.timer = window.setInterval(function () {
        if (self.isOpen || self.hovering || document.hidden || Date.now() < self.pauseUntil) return;
        self.scrollByStep(1);
      }, this.opts.autoSlideSpeed);
    }

    stopAuto() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }

    pauseAutoFor(ms) {
      this.pauseUntil = Date.now() + ms;
    }

    handleBlockSelect(event) {
      if (!event.detail || !event.detail.blockId) return;
      var card = this.querySelector('[data-block-id="' + event.detail.blockId + '"]');
      if (!card) return;
      this.pauseAutoFor(60000);
      this.track.scrollTo({ left: Math.max(0, card.offsetLeft - 6), behavior: 'smooth' });
    }

    /* ---------- Card videos ---------- */
    setupCardVideos() {
      var self = this;
      this.cardVideos = Array.prototype.slice.call(this.querySelectorAll('.vt-wab__video'));

      this.playCardVideo = function (video) {
        if (self.isOpen || self.opts.playback === 'none') return;
        if (!video.getAttribute('src') && video.dataset.src) {
          video.src = video.dataset.src;
        }
        video.muted = true;
        video.defaultMuted = true;
        var promise = video.play();
        if (promise && typeof promise.catch === 'function') promise.catch(function () {});
      };

      if (!this.cardVideos.length || this.opts.playback === 'none') return;

      if (this.opts.playback === 'autoplay') {
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              var video = entry.target;
              video.dataset.visible = entry.isIntersecting ? 'true' : 'false';
              if (entry.isIntersecting) self.playCardVideo(video);
              else video.pause();
            });
          }, { threshold: 0.35 });
          this.cardVideos.forEach(function (video) { self.io.observe(video); });
        } else {
          this.cardVideos.forEach(function (video) { self.playCardVideo(video); });
        }
      }

      if (this.opts.playback === 'hover' && !this.isTouch) {
        this.cards.forEach(function (card) {
          var video = card.querySelector('.vt-wab__video');
          if (!video) return;
          card.addEventListener('mouseenter', function () { self.playCardVideo(video); });
          card.addEventListener('mouseleave', function () { video.pause(); });
        });
      }
    }

    pauseCardVideos() {
      (this.cardVideos || []).forEach(function (video) { video.pause(); });
    }

    resumeCardVideos() {
      if (this.opts.playback !== 'autoplay') return;
      var self = this;
      (this.cardVideos || []).forEach(function (video) {
        if (!self.io || video.dataset.visible === 'true') self.playCardVideo(video);
      });
    }

    /* ---------- Popup ---------- */
    buildPopup() {
      if (this.popup) return;
      var self = this;
      var wrapper = this.closest('.vt-wab');
      var popup = document.createElement('div');
      popup.className = 'vt-wab-popup';
      popup.hidden = true;
      popup.setAttribute('role', 'dialog');
      popup.setAttribute('aria-modal', 'true');
      popup.setAttribute('aria-label', this.opts.label);
      if (wrapper && wrapper.getAttribute('style')) popup.setAttribute('style', wrapper.getAttribute('style'));

      popup.innerHTML =
        '<div class="vt-wab-popup__backdrop" data-close></div>' +
        '<div class="vt-wab-popup__stage" data-stage></div>' +
        '<button type="button" class="vt-wab-popup__nav vt-wab-popup__nav--prev" data-prev aria-label="Previous video">' + ICONS.prev + '</button>' +
        '<div class="vt-wab-popup__player" data-player>' +
          '<video class="vt-wab-popup__video" data-video playsinline loop preload="auto" disablepictureinpicture></video>' +
          '<img class="vt-wab-popup__poster" data-poster alt="" hidden>' +
          '<span class="vt-wab-popup__spinner" aria-hidden="true"></span>' +
          '<span class="vt-wab-popup__paused" aria-hidden="true">' + ICONS.play + '</span>' +
          '<div class="vt-wab-popup__top">' +
            '<button type="button" class="vt-wab-popup__icon-btn" data-mute aria-label="Unmute video">' + ICONS.muted + '</button>' +
            '<button type="button" class="vt-wab-popup__icon-btn" data-close aria-label="Close">' + ICONS.close + '</button>' +
          '</div>' +
          '<p class="vt-wab-popup__toast" data-toast role="status" aria-live="polite"></p>' +
          '<div class="vt-wab-popup__bottom">' +
            '<div class="vt-wab-popup__side" data-side>' +
              '<button type="button" class="vt-wab-popup__icon-btn" data-share aria-label="Share">' + ICONS.share + '</button>' +
              '<span class="vt-wab-popup__side-label" data-share-label></span>' +
            '</div>' +
            '<div class="vt-wab-pc" data-pc>' +
              '<div class="vt-wab-pc__row">' +
                '<img class="vt-wab-pc__img" data-pc-img alt="" width="48" height="60">' +
                '<div class="vt-wab-pc__meta">' +
                  '<p class="vt-wab-pc__title" data-pc-title></p>' +
                  '<p class="vt-wab-pc__price"><span data-pc-price></span><s class="vt-wab-pc__was" data-pc-was hidden></s><span class="vt-wab-pc__picked" data-pc-picked hidden></span></p>' +
                '</div>' +
                '<a class="vt-wab-pc__link" data-pc-link href="#" aria-label="View product">' + ICONS.link + '</a>' +
              '</div>' +
              '<button type="button" class="vt-wab-pc__atc" data-pc-atc></button>' +
              '<div class="vt-wab-pc__picker" data-pc-picker hidden>' +
                '<div class="vt-wab-pc__options" data-pc-options></div>' +
                '<div class="vt-wab-pc__actions">' +
                  '<button type="button" class="vt-wab-pc__cancel" data-pc-cancel></button>' +
                  '<button type="button" class="vt-wab-pc__done" data-pc-done></button>' +
                '</div>' +
              '</div>' +
              '<div class="vt-wab-pc__bar" data-pc-bar hidden>' +
                '<button type="button" class="vt-wab-pc__go" data-pc-go>' + ICONS.cart + '</button>' +
                '<div class="vt-wab-pc__qty">' +
                  '<button type="button" class="vt-wab-pc__step" data-pc-minus aria-label="Decrease quantity">' + ICONS.minus + '</button>' +
                  '<span class="vt-wab-pc__count" data-pc-count aria-live="polite">1</span>' +
                  '<button type="button" class="vt-wab-pc__step" data-pc-plus aria-label="Increase quantity">' + ICONS.plus + '</button>' +
                '</div>' +
              '</div>' +
              '<p class="vt-wab-pc__msg" data-pc-msg role="status" aria-live="polite"></p>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="vt-wab-popup__nav vt-wab-popup__nav--next" data-next aria-label="Next video">' + ICONS.next + '</button>';

      document.body.appendChild(popup);
      this.popup = popup;

      this.stage = popup.querySelector('[data-stage]');
      this.player = popup.querySelector('[data-player]');
      this.video = popup.querySelector('[data-video]');
      this.posterImg = popup.querySelector('[data-poster]');
      this.muteBtn = popup.querySelector('[data-mute]');
      this.toastEl = popup.querySelector('[data-toast]');
      this.pc = popup.querySelector('[data-pc]');
      this.pcImg = popup.querySelector('[data-pc-img]');
      this.pcTitle = popup.querySelector('[data-pc-title]');
      this.pcPrice = popup.querySelector('[data-pc-price]');
      this.pcWas = popup.querySelector('[data-pc-was]');
      this.pcLink = popup.querySelector('[data-pc-link]');
      this.pcOptions = popup.querySelector('[data-pc-options]');
      this.pcAtc = popup.querySelector('[data-pc-atc]');
      this.pcMsg = popup.querySelector('[data-pc-msg]');
      this.pcPicker = popup.querySelector('[data-pc-picker]');
      this.pcBar = popup.querySelector('[data-pc-bar]');
      this.pcCount = popup.querySelector('[data-pc-count]');
      this.pcPicked = popup.querySelector('[data-pc-picked]');
      this.pcGo = popup.querySelector('[data-pc-go]');
      popup.querySelector('[data-pc-cancel]').textContent = this.opts.text.cancel;
      popup.querySelector('[data-pc-done]').textContent = this.opts.text.done;
      this.pcGo.setAttribute('aria-label', this.opts.text.checkout);
      this.pcGo.title = this.opts.text.checkout;

      popup.querySelector('[data-share-label]').textContent = this.opts.text.share;

      if (!this.opts.showMute) this.muteBtn.remove();
      if (!this.opts.showShare) popup.querySelector('[data-side]').remove();
      if (!this.opts.showProduct) {
        this.pc.remove();
        this.pc = null;
      }

      /* Neighbour thumbnails */
      this.ghosts = [];
      if (this.opts.showNeighbours) {
        this.items.forEach(function (item, i) {
          var ghost = document.createElement('button');
          ghost.type = 'button';
          ghost.className = 'vt-wab-popup__ghost';
          ghost.dataset.ghost = String(i);
          ghost.tabIndex = -1;
          ghost.setAttribute('aria-label', 'Play video: ' + (item.title || 'Video ' + (i + 1)));
          if (item.poster) {
            var img = document.createElement('img');
            img.src = item.poster;
            img.alt = '';
            img.loading = 'lazy';
            ghost.appendChild(img);
          }
          self.stage.appendChild(ghost);
          self.ghosts.push(ghost);
        });
      }

      /* Clicks */
      popup.addEventListener('click', function (event) {
        var target = event.target;
        if (target.closest('[data-close]')) { self.close(); return; }
        if (target.closest('[data-prev]')) { self.go(self.index - 1); return; }
        if (target.closest('[data-next]')) { self.go(self.index + 1); return; }
        if (target.closest('[data-mute]')) { self.toggleMute(); return; }
        if (target.closest('[data-share]')) { self.share(); return; }
        var ghost = target.closest('[data-ghost]');
        if (ghost) { self.go(parseInt(ghost.dataset.ghost, 10)); return; }
        var optionBtn = target.closest('[data-opt-index]');
        if (optionBtn) { self.selectOption(optionBtn); return; }
        if (target.closest('[data-pc-atc]')) { self.onAtc(); return; }
        if (target.closest('[data-pc-cancel]')) { self.closePicker(); return; }
        if (target.closest('[data-pc-done]')) { self.onDone(); return; }
        if (target.closest('[data-pc-go]')) { self.goToCart(); return; }
        if (target.closest('[data-pc-plus]')) { self.changeQty(1); return; }
        if (target.closest('[data-pc-minus]')) { self.changeQty(-1); return; }
        if (target === self.video) { self.togglePlay(); }
      });

      /* Swipe on the player */
      this.player.addEventListener('touchstart', function (event) {
        if (event.target.closest('.vt-wab-pc')) return;
        self._touchX = event.touches[0].clientX;
        self._touchY = event.touches[0].clientY;
      }, { passive: true });

      this.player.addEventListener('touchend', function (event) {
        if (self._touchX == null) return;
        var dx = event.changedTouches[0].clientX - self._touchX;
        var dy = event.changedTouches[0].clientY - self._touchY;
        self._touchX = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          self.go(self.index + (dx < 0 ? 1 : -1));
        } else if (Math.abs(dy) > 70 && Math.abs(dy) > Math.abs(dx)) {
          self.go(self.index + (dy < 0 ? 1 : -1));
        }
      }, { passive: true });

      /* Video loading state */
      this.video.addEventListener('waiting', function () { self.player.classList.add('is-loading'); });
      this.video.addEventListener('playing', function () { self.player.classList.remove('is-loading', 'is-paused'); });
      this.video.addEventListener('canplay', function () { self.player.classList.remove('is-loading'); });

      this.onKey = function (event) {
        if (!self.isOpen) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          self.close();
        } else if (event.key === 'ArrowRight') {
          self.go(self.index + 1);
        } else if (event.key === 'ArrowLeft') {
          self.go(self.index - 1);
        } else if (event.key === 'Tab') {
          self.trapFocus(event);
        }
      };
    }

    open(index, trigger) {
      if (!this.items.length) return;
      this.buildPopup();
      this.lastFocus = trigger || document.activeElement;
      this.isOpen = true;
      this.muted = !this.opts.soundOnOpen;
      this.pauseCardVideos();

      this.popup.classList.toggle('is-single', this.items.length < 2);
      this.popup.hidden = false;
      document.documentElement.classList.add('vt-wab-lock');
      document.addEventListener('keydown', this.onKey);

      /* Called directly inside the click, so the browser allows sound */
      this.go(index);
      this.refreshCart();

      var closeBtn = this.popup.querySelector('.vt-wab-popup__top [data-close]');
      window.requestAnimationFrame(function () {
        if (closeBtn) closeBtn.focus({ preventScroll: true });
      });
    }

    close(silent) {
      if (!this.isOpen) return;
      this.isOpen = false;
      window.clearTimeout(this._addedTimer);
      window.clearTimeout(this._toastTimer);

      if (this.video) {
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.load();
      }
      if (this.popup) this.popup.hidden = true;
      document.documentElement.classList.remove('vt-wab-lock');
      document.removeEventListener('keydown', this.onKey);

      if (silent) return;
      this.pauseAutoFor(3000);
      this.resumeCardVideos();
      if (this.lastFocus && typeof this.lastFocus.focus === 'function') {
        this.lastFocus.focus({ preventScroll: true });
      }
    }

    go(index) {
      var count = this.items.length;
      if (!count) return;
      this.index = ((index % count) + count) % count;
      var item = this.items[this.index];
      this.renderGhosts();
      this.loadVideo(item);
      this.renderProduct(item);
    }

    renderGhosts() {
      if (!this.ghosts || !this.ghosts.length) return;
      var count = this.items.length;
      var current = this.index;

      this.ghosts.forEach(function (ghost, i) {
        var offset = i - current;
        if (count > 2) {
          if (offset > count / 2) offset -= count;
          if (offset < -count / 2) offset += count;
        }
        var distance = Math.abs(offset);

        if (offset === 0 || distance > 2) {
          ghost.style.transform = 'translate(-50%, -50%) scale(0.7)';
          ghost.style.opacity = '0';
          ghost.style.zIndex = '0';
          ghost.style.pointerEvents = 'none';
          ghost.style.filter = '';
        } else if (distance === 1) {
          ghost.style.transform = 'translate(-50%, -50%) translateX(' + offset * 62 + '%) scale(0.84)';
          ghost.style.opacity = '1';
          ghost.style.zIndex = '2';
          ghost.style.pointerEvents = 'auto';
          ghost.style.filter = 'brightness(0.7)';
        } else {
          ghost.style.transform = 'translate(-50%, -50%) translateX(' + offset * 112 + '%) scale(0.66)';
          ghost.style.opacity = '1';
          ghost.style.zIndex = '1';
          ghost.style.pointerEvents = 'auto';
          ghost.style.filter = 'brightness(0.5)';
        }
      });
    }

    loadVideo(item) {
      var self = this;
      var video = this.video;
      video.pause();
      this.player.classList.remove('is-paused');
      this.posterImg.hidden = true;

      if (item.video) {
        video.hidden = false;
        this.player.classList.add('is-loading');
        if (item.poster) video.poster = item.poster;
        else video.removeAttribute('poster');
        video.src = item.video;
        video.muted = this.muted;

        var promise = video.play();
        if (promise && typeof promise.catch === 'function') {
          promise.catch(function (error) {
            if (error && error.name === 'AbortError') return;
            if (!video.muted) {
              /* Browser blocked sound: fall back to muted playback */
              video.muted = true;
              self.muted = true;
              self.updateMuteBtn();
              video.play().catch(function () {
                self.player.classList.remove('is-loading');
                self.player.classList.add('is-paused');
              });
            } else {
              self.player.classList.remove('is-loading');
              self.player.classList.add('is-paused');
            }
          });
        }
      } else {
        video.removeAttribute('src');
        video.load();
        video.hidden = true;
        this.player.classList.remove('is-loading');
        if (item.poster) {
          this.posterImg.src = item.poster;
          this.posterImg.hidden = false;
        }
      }

      if (this.muteBtn) this.muteBtn.hidden = !item.video;
      this.updateMuteBtn();
    }

    togglePlay() {
      var video = this.video;
      if (!video.getAttribute('src')) return;
      if (video.paused) {
        video.play().catch(function () {});
        this.player.classList.remove('is-paused');
      } else {
        video.pause();
        this.player.classList.add('is-paused');
      }
    }

    toggleMute() {
      this.muted = !this.muted;
      this.video.muted = this.muted;
      if (!this.muted && this.video.paused && this.video.getAttribute('src')) {
        this.video.play().catch(function () {});
        this.player.classList.remove('is-paused');
      }
      this.updateMuteBtn();
    }

    updateMuteBtn() {
      if (!this.muteBtn) return;
      this.muteBtn.innerHTML = this.muted ? ICONS.muted : ICONS.sound;
      this.muteBtn.setAttribute('aria-label', this.muted ? 'Unmute video' : 'Mute video');
    }

    share() {
      var self = this;
      var item = this.items[this.index];
      if (!item) return;
      var path = item.product ? item.product.url : window.location.pathname;
      var url = new URL(path, window.location.origin).href;
      var title = item.title || document.title;

      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
        return;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          self.toast(self.opts.text.copied);
        }).catch(function () {
          window.prompt(title, url);
        });
      } else {
        window.prompt(title, url);
      }
    }

    toast(message, withTick) {
      var el = this.toastEl;
      if (!el) return;
      el.innerHTML = '';
      if (withTick) {
        var tick = document.createElement('span');
        tick.className = 'vt-wab-popup__toast-tick';
        tick.innerHTML = ICONS.check;
        el.appendChild(tick);
      }
      el.appendChild(document.createTextNode(message));
      el.classList.remove('is-visible');
      void el.offsetWidth;
      el.classList.add('is-visible');
      window.clearTimeout(this._toastTimer);
      this._toastTimer = window.setTimeout(function () {
        el.classList.remove('is-visible');
      }, 2200);
    }

    trapFocus(event) {
      var focusable = Array.prototype.slice.call(
        this.popup.querySelectorAll('button:not([disabled]), a[href], [tabindex]')
      ).filter(function (el) {
        return el.tabIndex >= 0 && !el.hidden && el.getClientRects().length > 0;
      });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      } else if (!this.popup.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    }

    /* ---------- Product card ----------
       Views: 'atc'    -> Add to cart button
              'picker' -> size buttons + Cancel / Done
              'bar'    -> cart icon + quantity (item is in the cart)
    --------------------------------------------------------------------- */
    renderProduct(item) {
      if (!this.pc) return;
      var product = item.product;
      window.clearTimeout(this._addedTimer);

      if (!product || !product.variants || !product.variants.length) {
        this.pc.hidden = true;
        this.product = null;
        return;
      }

      this.pc.hidden = false;
      this.product = product;
      this.variant = null;
      this.pickerOpen = false;

      this.pcTitle.textContent = item.title || product.title;
      this.pcLink.href = product.url;
      this.pcLink.setAttribute('aria-label', 'View product: ' + product.title);
      this.clearMsg();

      this.groups = this.buildGroups(product);
      this.resetSelection();
      this.renderOptions();
      this.updateVariant();
      this.syncView();
    }

    /* Every option with its values. Options with only one value (for example a
       single colour) are chosen automatically and not shown. */
    buildGroups(product) {
      var groups = [];
      (product.options || []).forEach(function (name, i) {
        var values = [];
        product.variants.forEach(function (variant) {
          var value = variant.options[i];
          if (value != null && values.indexOf(value) === -1) values.push(value);
        });
        groups.push({ name: name, index: i, values: values, visible: values.length > 1 });
      });
      return groups;
    }

    resetSelection() {
      var self = this;
      this.selected = this.groups.map(function (group) {
        return group.values.length === 1 ? group.values[0] : null;
      });
      /* If only one size can be bought, pick it for the customer */
      this.groups.forEach(function (group) {
        if (!group.visible) return;
        var buyable = group.values.filter(function (value) {
          return self.product.variants.some(function (v) { return v.available && v.options[group.index] === value; });
        });
        if (buyable.length === 1) self.selected[group.index] = buyable[0];
      });
    }

    hasVisibleOptions() {
      return this.opts.showVariants && !this.product.hasOnlyDefault &&
        this.groups.some(function (group) { return group.visible; });
    }

    renderOptions() {
      var wrap = this.pcOptions;
      wrap.innerHTML = '';
      if (!this.hasVisibleOptions()) return;

      this.groups.forEach(function (group) {
        if (!group.visible) return;
        var box = document.createElement('div');
        box.className = 'vt-wab-pc__opt';
        box.setAttribute('role', 'radiogroup');
        box.setAttribute('aria-label', group.name);

        var label = document.createElement('p');
        label.className = 'vt-wab-pc__opt-name';
        label.textContent = group.name;

        var list = document.createElement('div');
        list.className = 'vt-wab-pc__values';

        group.values.forEach(function (value) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'vt-wab-pc__value';
          btn.textContent = value;
          btn.dataset.optIndex = String(group.index);
          btn.dataset.optValue = value;
          btn.setAttribute('role', 'radio');
          list.appendChild(btn);
        });

        box.appendChild(label);
        box.appendChild(list);
        wrap.appendChild(box);
      });
    }

    selectOption(button) {
      if (button.classList.contains('is-unavailable')) return;
      var i = parseInt(button.dataset.optIndex, 10);
      this.selected[i] = button.dataset.optValue;
      this.clearMsg();
      this.updateVariant();
    }

    findVariant() {
      var self = this;
      if (this.selected.some(function (value) { return value == null; })) return null;
      return this.product.variants.filter(function (v) {
        return v.options.every(function (option, i) { return option === self.selected[i]; });
      })[0] || null;
    }

    updateVariant() {
      var self = this;
      var product = this.product;
      if (!product) return;

      var variant = this.findVariant();
      this.variant = variant;

      /* Size buttons: selected / sold out */
      this.pcOptions.querySelectorAll('[data-opt-index]').forEach(function (btn) {
        var i = parseInt(btn.dataset.optIndex, 10);
        var value = btn.dataset.optValue;
        var isSelected = self.selected[i] === value;
        btn.classList.toggle('is-selected', isSelected);
        btn.setAttribute('aria-checked', isSelected ? 'true' : 'false');

        var possible = product.variants.some(function (v) {
          return v.available && v.options[i] === value && v.options.every(function (option, j) {
            return j === i || self.selected[j] == null || option === self.selected[j];
          });
        });
        btn.classList.toggle('is-unavailable', !possible);
        btn.setAttribute('aria-disabled', possible ? 'false' : 'true');
      });

      this.renderPrice(variant);

      /* Main button */
      if (!product.available || !product.variants.some(function (v) { return v.available; })) {
        this.setAtcState('soldout');
      } else {
        this.setAtcState('ready');
      }

      var done = this.popup.querySelector('[data-pc-done]');
      if (done) done.classList.toggle('is-waiting', !(variant && variant.available));
    }

    renderPrice(variant) {
      var product = this.product;
      var source = variant ||
        product.variants.filter(function (v) { return v.available; })[0] ||
        product.variants[0];

      var image = (variant && variant.image) || product.image;
      if (image) {
        this.pcImg.src = image;
        this.pcImg.style.visibility = 'visible';
      } else {
        this.pcImg.removeAttribute('src');
        this.pcImg.style.visibility = 'hidden';
      }

      this.pcPrice.textContent = source ? source.price : '';
      if (this.opts.showCompare && source && source.compare) {
        this.pcWas.textContent = source.compare;
        this.pcWas.hidden = false;
      } else {
        this.pcWas.textContent = '';
        this.pcWas.hidden = true;
      }
    }

    /* Only the options a customer actually chooses, e.g. "M" */
    pickedLabel(variant) {
      if (!variant || !this.groups) return '';
      return this.groups.filter(function (g) { return g.visible; }).map(function (g) {
        return variant.options[g.index];
      }).join(' / ');
    }

    setAtcState(state) {
      var btn = this.pcAtc;
      var t = this.opts.text;
      btn.classList.remove('is-loading', 'is-added');
      btn.disabled = false;

      switch (state) {
        case 'adding':
          btn.textContent = t.adding;
          btn.classList.add('is-loading');
          btn.disabled = true;
          break;
        case 'soldout':
          btn.textContent = t.soldout;
          btn.disabled = true;
          break;
        default:
          btn.textContent = t.add;
      }
    }

    showView(view) {
      this.view = view;
      this.pcAtc.hidden = view !== 'atc';
      this.pcPicker.hidden = view !== 'picker';
      this.pcBar.hidden = view !== 'bar';
      this.pc.classList.toggle('is-picking', view === 'picker');
    }

    /* Decide which view to show from the cart contents */
    syncView() {
      if (!this.product) return;
      if (this.pickerOpen) { this.showView('picker'); return; }

      var line = this.lineForProduct();
      if (line) {
        this.pcCount.textContent = String(line.quantity);
        var variant = this.product.variants.filter(function (v) { return v.id === line.variant_id; })[0];
        var label = this.pickedLabel(variant);
        this.pcPicked.textContent = label;
        this.pcPicked.hidden = !label;
        if (variant) this.renderPrice(variant);
        this.showView('bar');
      } else {
        this.pcPicked.hidden = true;
        this.renderPrice(this.variant);
        this.showView('atc');
      }
    }

    lineForProduct() {
      if (!this.cart || !this.cart.items || !this.product) return null;
      var productId = this.product.id;
      var lines = this.cart.items.filter(function (line) { return line.product_id === productId; });
      if (!lines.length) return null;
      var last = this.lastAdded && this.lastAdded[productId];
      return lines.filter(function (line) { return line.variant_id === last; })[0] || lines[0];
    }

    onAtc() {
      if (!this.product || this._busy) return;
      this.clearMsg();
      if (!this.hasVisibleOptions()) {
        /* No sizes to choose: add straight away */
        var variant = this.findVariant() ||
          this.product.variants.filter(function (v) { return v.available; })[0];
        if (variant && variant.available) this.addToCart(variant);
        return;
      }
      this.resetSelection();
      this.updateVariant();
      this.pickerOpen = true;
      this.showView('picker');
      var first = this.pcOptions.querySelector('.vt-wab-pc__value:not(.is-unavailable)');
      if (first) first.focus({ preventScroll: true });
    }

    closePicker() {
      this.pickerOpen = false;
      this.clearMsg();
      this.resetSelection();
      this.updateVariant();
      this.syncView();
      if (this.view === 'atc') this.pcAtc.focus({ preventScroll: true });
    }

    onDone() {
      if (this._busy) return;
      var variant = this.findVariant();
      if (!variant) {
        this.showMsg(this.opts.text.select);
        var box = this.pcOptions;
        box.classList.remove('is-shake');
        void box.offsetWidth;
        box.classList.add('is-shake');
        return;
      }
      if (!variant.available) {
        this.showMsg(this.opts.text.soldout);
        return;
      }
      this.addToCart(variant);
    }

    showMsg(text) {
      this.pcMsg.textContent = text;
      this.pcMsg.classList.add('is-error');
    }

    clearMsg() {
      if (!this.pcMsg) return;
      this.pcMsg.textContent = '';
      this.pcMsg.classList.remove('is-error');
    }

    setBusy(busy) {
      this._busy = busy;
      if (this.pc) this.pc.classList.toggle('is-busy', busy);
    }

    /* ---------- Cart requests ---------- */
    request(path, body) {
      var self = this;
      var options = { headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
      if (body) {
        options.method = 'POST';
        options.headers['Content-Type'] = 'application/json';
        options.body = JSON.stringify(body);
      }
      return fetch(this.opts.rootUrl + path, options).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || (data && data.status && data.status >= 400)) {
            throw new Error((data && (data.description || data.message)) || self.opts.text.error);
          }
          return data;
        });
      });
    }

    refreshCart() {
      var self = this;
      return this.request('cart.js').then(function (cart) {
        self.cart = cart;
        self.updateCounts(cart.item_count);
        if (self.isOpen) self.syncView();
        return cart;
      }).catch(function () {});
    }

    addToCart(variant) {
      var self = this;
      var productId = this.product.id;
      this.setBusy(true);
      this.clearMsg();
      if (this.view === 'atc') this.setAtcState('adding');

      this.request('cart/add.js', { id: variant.id, quantity: 1 })
        .then(function () { return self.request('cart.js'); })
        .then(function (cart) {
          self.cart = cart;
          self.lastAdded = self.lastAdded || {};
          self.lastAdded[productId] = variant.id;
          self.updateCounts(cart.item_count);
          self.announce(cart, variant.id);

          if (self.opts.afterAdd === 'cart') {
            window.location.href = self.opts.cartUrl;
            return;
          }
          if (self.opts.afterAdd === 'drawer') {
            self.openDrawer(variant.id);
            return;
          }

          self.pickerOpen = false;
          self.toast(self.opts.text.added, true);
          if (self.product && self.product.id === productId) {
            self.updateVariant();
            self.syncView();
            self.pcGo.focus({ preventScroll: true });
          }
        })
        .catch(function (error) {
          self.showMsg((error && error.message) || self.opts.text.error);
          if (self.product && self.product.id === productId) self.updateVariant();
        })
        .then(function () { self.setBusy(false); });
    }

    changeQty(delta) {
      var self = this;
      var line = this.lineForProduct();
      if (!line || this._busy) return;
      var wanted = Math.max(0, line.quantity + delta);
      var productId = this.product.id;
      this.setBusy(true);
      this.clearMsg();

      this.request('cart/change.js', { id: line.key, quantity: wanted })
        .then(function (cart) {
          self.cart = cart;
          self.updateCounts(cart.item_count);
          self.announce(cart, line.variant_id);

          var now = cart.items.filter(function (item) { return item.key === line.key; })[0];
          var qty = now ? now.quantity : 0;
          if (delta > 0 && qty < wanted) self.showMsg(self.opts.text.max);
          else if (wanted === 0) self.toast(self.opts.text.removed, false);
          else if (delta > 0) self.toast(self.opts.text.added, true);

          if (self.product && self.product.id === productId) self.syncView();
        })
        .catch(function (error) {
          self.showMsg((error && error.message) || self.opts.text.error);
        })
        .then(function () { self.setBusy(false); });
    }

    goToCart() {
      var action = this.opts.cartIconAction;
      if (action === 'drawer') {
        var line = this.lineForProduct();
        this.openDrawer(line ? line.variant_id : null);
      } else if (action === 'cart') {
        window.location.href = this.opts.cartUrl;
      } else {
        window.location.href = this.opts.rootUrl + 'checkout';
      }
    }

    openDrawer(variantId) {
      var self = this;
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.renderContents !== 'function') {
        window.location.href = this.opts.cartUrl;
        return;
      }
      fetch(this.opts.rootUrl + '?sections=cart-drawer,cart-icon-bubble')
        .then(function (response) { return response.json(); })
        .then(function (sections) {
          self.close();
          drawer.classList.remove('is-empty');
          drawer.renderContents({ id: variantId, sections: sections });
        })
        .catch(function () {
          window.location.href = self.opts.cartUrl;
        });
    }

    /* Header, bottom bar and theme cart all show the new count */
    updateCounts(count) {
      var selectors = '[data-vh-cart-count], [data-vt-bn-count], [data-cart-count], .cart-count-bubble span[aria-hidden="true"]';
      document.querySelectorAll(selectors).forEach(function (el) {
        el.textContent = String(count);
        el.hidden = count === 0;
      });
    }

    announce(cart, variantId) {
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'vt-watch-and-buy', productVariantId: variantId, cartData: cart });
        }
      } catch (e) {}
      document.dispatchEvent(new CustomEvent('vt-wab:cart-updated', { detail: { cart: cart, variantId: variantId } }));
    }
  }

  window.customElements.define('vt-watch-and-buy', VTWatchAndBuy);
})();